<template>
  <section class="beginning">
    <div class="v2-container-small">
      <h2 class="beginning__title">
        новости и события
        <br>
        онлайн-школы
      </h2>

      <div class="beginning__controls">
        <img
          src="/v2/ege/long-journey/arrow-left.svg"
          alt="prev"
          @click="prevSlide"
        >
        <img
          src="/v2/ege/long-journey/arrow-right.svg"
          alt="next"
          @click="nextSlide"
        >
      </div>
    </div>

    <div class="beginning__content">
      <custom-scroll-slider
        ref="slider"
        class="beginning__slider"
        :items="cardsList"
        :container-width="1240"
        :gap="10"
        by-step
        @updateSlideNumber="slideNumber = $event"
      >
        <template #item="{ slide }">
          <component
            :is="slide.link ? 'a' : 'div'"
            :href="slide.link ? slide.link : null"
            :target="slide.link ? '_blank' : null"
            class="card"
            @dragstart.prevent
          >
            <div class="card__image">
              <img
                :src="slide.image"
                alt="image"
              >
            </div>

            <div class="card__text">
              <h6 class="card__text--title">
                {{ slide.date }}
              </h6>
              <p class="card__text--text">
                {{ slide.text }}
              </p>
            </div>
          </component>
        </template>
      </custom-scroll-slider>
    </div>
  </section>
</template>

<script>
import CustomScrollSlider from '~/components/v2/common/CustomScrollSlider.vue';

export default {
  name: 'SchoolNewsAndEvents',
  components: {
    CustomScrollSlider,
  },

  data: () => ({
    cardsList: [
      {
        id: 1,
        date: '01.06.2024',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'Выставка Навигатор Поступления. Онлайн-школа Синергия приняла участие в выставке школ, вызов и колледжей Навигатор поступления на площадке Main Stage',
        image: '/v2/ege/news/1.webp',
        link: null,
      },
      {
        id: 2,
        date: '01.06.2024',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'Преподаватель ИЗО в онлайн-школе Синергия, Анна Александровна, провела мастер-класс для участников фестиваля семейного образование «Наследники»',
        image: '/v2/ege/news/2.webp',
        link: null,
      },
      {
        id: 3,
        date: '24.05.2024',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'Для 9 и 11 классов команда онлайн-школы «Синергия» провела волшебный последний звонок в стиле Гарри Поттера. Было весело!',
        image: '/v2/ege/news/3.webp',
        link: null,
      },
      {
        id: 4,
        date: '21.05.2024',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'Команда кураторов онлайн-школы Синергия сопроводила первую группу учеников на ОГЭ по английскому языку. Помогли ребятам собраться с мыслями и пожелали удачи!',
        image: '/v2/ege/news/4.webp',
        link: null,
      },
      {
        id: 5,
        date: '18.05.2024',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'На турнире Кубок «Синергии» по игре «Мир Танков» онлайн-школа «Синергия» представила новый Киберспортивный класс с упором на гейм дизайн и разработку игр',
        image: '/v2/ege/news/5.webp',
        link: null,
      },
      {
        id: 6,
        date: '16.05.2024',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'Ученица 9 класса и команды онлайн-школы Синергия приняла участие в съемках шоу «Как стать звездой» совместно со студией Vocal Mix',
        image: '/v2/ege/news/6.webp',
        link: null,
      },
      {
        id: 7,
        date: '29.04.2024',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'Ученица 5 класса, Арина, и команда онлайн-школы Синергия наградили победителей и участников олимпиады по русскому языку среди 5–6 классов',
        image: '/v2/ege/news/7.webp',
        link: null,
      },
      {
        id: 8,
        date: '28.04.2024',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'Онлайн-школа Синергия приняла участие в выставке альтернативного образования Я расту в России на площадке Novotel',
        image: '/v2/ege/news/8.webp',
        link: null,
      },
      {
        id: 9,
        date: '10.03.2024',
        // eslint-disable-next-line max-len,vue/max-len
        text: 'Выставка «Образование и карьера». Онлайн-школа «Синергия» приняла участие в крупнейшей образовательной выставке в центре Москвы',
        image: '/v2/ege/news/9.webp',
        link: null,
      },
    ],
    slideNumber: 1,
  }),

  computed: {
    examType() {
      return this.$route.name.includes('oge') ? 'ОГЭ' : 'ЕГЭ';
    },
  },

  methods: {
    nextSlide() {
      this.$refs.slider.nextSlide();
    },
    prevSlide() {
      this.$refs.slider.prevSlide();
    },
  },
};
</script>

<style lang="scss" scoped>
.beginning {
  &__title {
    font-size: 45px;
    font-weight: 700;
    line-height: 110%;
    letter-spacing: -0.03em;
    color: $black-color;
    text-transform: uppercase;

    ::v-deep & > span {
      display: inline-block;
      position: relative;

      &:before {
        content: '';
        width: 102%;
        height: 100%;
        background-color: $ege-orange;
        box-shadow: 0 2px 35px 0 rgba($blue-darkest, .2);
        position: absolute;
        left: -1%;
        bottom: -2%;
      }

      span {
        position: relative;
        z-index: 2;
        color: $white-color;
      }
    }

    @include media-down(tablet) {
      padding: 0 8px;
      font-size: 30px;
    }
  }

  &__controls {
    position: absolute;
    right: 10px;
    top: 54px;
    display: flex;
    gap: 10px;

    @include media-down(tablet) {
      display: none;
    }

    img {
      cursor: pointer;
    }
  }

  &__content {
    margin-top: 60px;

    @include media-down(tablet) {
      margin-top: 32px;
    }
  }

  &__slider {
    padding-bottom: 60px;
    padding-top: 60px;
    margin-top: -60px;
    margin-bottom: -60px;

    .card {
      display: block;
      width: 310px;
      filter: drop-shadow(10px 10px 30px rgba($ege-blue-darkest, .2));

      &__image {
        position: relative;
        overflow: hidden;

        border-radius: 20px;
        line-height: 0;

        img {
          width: 100%;
        }
      }

      &__text {
        padding: 16px 20px 16px 20px;

        border-radius: 20px;
        background-color: $white-color;

        &--title {
          font-size: 16px;
          font-weight: 700;
          line-height: 131%;
          color: $black-color;
        }

        &--text {
          margin-top: 8px;

          font-size: 18px;
          font-weight: 500;
          line-height: 128%;
          letter-spacing: -0.01em;
          color: $grey2;
        }
      }
    }
  }
}
</style>
